export function init() {
  const FB = window.FB;
  return new Promise(res => {
    FB.init({
      appId: process.env.REACT_APP_FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: "v3.0"
    });
    FB.getLoginStatus(function(currentStatusResp) {
      if (currentStatusResp.status === "connected") {
        res(currentStatusResp.authResponse.accessToken);
      } else {
        res(null);
      }
    });
  });
}

export function login(token) {
  const FB = window.FB;
  if (token) {
    return token;
  }
  return new Promise((res, rej) => {
    return FB.login(function(loginResp) {
      if (loginResp.status === "connected") {
        res(loginResp.authResponse.accessToken);
      } else {
        rej();
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/modules/auth/facebook-effects.js